import { render, staticRenderFns } from "./Reg.vue?vue&type=template&id=ef7262f2&scoped=true"
import script from "./Reg.vue?vue&type=script&lang=js"
export * from "./Reg.vue?vue&type=script&lang=js"
import style0 from "./Reg.vue?vue&type=style&index=0&id=ef7262f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7262f2",
  null
  
)

export default component.exports